import { z } from 'zod'
import { oc } from '@orpc/contract'

export const COMBINED_PDF_RESOURCE_TYPES = ['DiagnosticReport', 'DocumentReference'] as const
export const COMBINED_PDF_MAX_RECORDS = 100

/**
 * PD-1685 — several of a patient's chart records (Labs/Imaging results or Documents) as ONE
 * PDF, oldest first, every original page kept. Answers with the file itself; when any
 * selected record can't be included, nothing is built and the error message names them.
 */
export const chartRecordsCombinedPdf = oc
  .route({ method: 'POST', path: '/v2/patients/{patientId}/chart-records/combined-pdf' })
  .input(
    z.object({
      patientId: z.string(),
      resourceType: z.enum(COMBINED_PDF_RESOURCE_TYPES),
      recordIds: z
        .array(z.string().min(1).max(200))
        .min(1)
        .max(COMBINED_PDF_MAX_RECORDS)
        .refine((ids) => new Set(ids).size === ids.length, {
          message: 'Record ids must be unique',
        }),
    }),
  )
  .output(z.file())
